module.exports = __webpack_public_path__ + "static/media/expired.0bc49db8.png";